<script>
import { mapGetters } from 'vuex';
import MentionBox from '../mentions/MentionBox.vue';

export default {
  components: { MentionBox },
  props: {
    searchKey: {
      type: String,
      default: '',
    },
  },
  emits: ['replace'],
  computed: {
    ...mapGetters({
      privateCommands: 'getPrivateCommands',
    }),
    items() {
      return this.privateCommands.map(command => ({
        label: command.short_code,
        key: command.short_code,
        description: command.description || command.content,
      }));
    },
  },
  watch: {
    searchKey() {
      this.fetchPrivateCommands();
    },
  },
  mounted() {
    this.fetchPrivateCommands();
  },
  methods: {
    fetchPrivateCommands() {
      this.$store.dispatch('fetchPrivateCommands', {
        searchKey: this.searchKey,
      });
    },
    handleCommandClick(item = {}) {
      // Insert the content (short_code) into the editor
      this.$emit('replace', item.label);
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <MentionBox
    v-if="items.length"
    :items="items"
    @mention-select="handleCommandClick"
  />
</template>
